import { createSlice } from '@reduxjs/toolkit';
import { TenantData } from '../../lib/mockData';
import { fetchTenants } from './actions';

interface AdminTenantsState {
  tenants: TenantData[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
  isLoading: boolean;
  hasFetched: boolean;
  error: string | null;
}

const initialState: AdminTenantsState = {
  tenants: [],
  page: 1,
  limit: 20,
  total: 0,
  totalPages: 0,
  isLoading: false,
  hasFetched: false,
  error: null,
};

const adminTenantsSlice = createSlice({
  name: 'adminTenants',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTenants.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchTenants.fulfilled, (state, action) => {
        state.isLoading = false;
        state.hasFetched = true;
        state.tenants = action.payload.tenants;
        state.page = action.payload.pagination.page;
        state.limit = action.payload.pagination.limit;
        state.total = action.payload.pagination.total;
        state.totalPages = action.payload.pagination.totalPages;
      })
      .addCase(fetchTenants.rejected, (state, action) => {
        state.isLoading = false;
        state.error = (action.payload as string) || 'Erro ao buscar empresas';
      });
  },
});

export const adminTenantsReducer = adminTenantsSlice.reducer;
